module.exports = {
  BASE64: 'base64',
  UTF8: 'utf8',
  PRIVATE: 'private',
  PUBLIC: 'public',
  PKCS1: 'pkcs1',
  PKCS8: 'pkcs8',
  PEM: 'pem',
  DER: 'der'
};